import { Controller } from '@hotwired/stimulus'

// Connects to data-controller="flight-advisory-version-lookup"
// This controller fetches the advisory version from the provided advisory URL
// and displays it in the target element.
export default class extends Controller {
  static targets = ['output']
  static values = {
    url: String
  }

  connect () {
    fetch(this.urlValue + '/about.json')
      .then(response => response.json())
      .then(data => {
        this.outputTargets.forEach(element => {
          element.textContent = data._meta.advisory_version
        })
      })
      .catch((error) => {
        console.error('Error fetching advisory version:', error)
      })
  }
}
